import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=706ac4d2&scoped=true"
import script from "./RechargeDialog.vue?vue&type=script&lang=js"
export * from "./RechargeDialog.vue?vue&type=script&lang=js"
import style0 from "./RechargeDialog.vue?vue&type=style&index=0&id=706ac4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ac4d2",
  null
  
)

export default component.exports